import { useParams } from "react-router-dom";
import { MutableRefObject } from "react";

import { AgGridReact } from '@ag-grid-community/react';

import { useUserEventCount } from "src/features/shared/UserActivityTracking/TrackActivityCount";
import { useDeleteBomDataMutation, useDeleteOptionSectionMutation, useDeleteSectionMutation } from "../../queries";
import { PricingDataType, SelectedData } from "../types";
import { useKitPricingUpdate } from "./useKitPricingUpdate";

interface DeleteBodsProps {
    isOptionTable: boolean;
    tableRef?: MutableRefObject<AgGridReact<any> | null>
    onPricingInfoEdit?: (info: PricingDataType) => Promise<void>
}

const useDeleteBods = ({ isOptionTable, tableRef, onPricingInfoEdit }: DeleteBodsProps) => {
    const { bomId = '' } = useParams();
    const { pushUserEventCount } = useUserEventCount();
    const { handleKitPricingUpdate } = useKitPricingUpdate(bomId);
    const { mutateAsync: deleteSection, isLoading: deleteSectionLoading } = useDeleteSectionMutation();

    const { mutateAsync: deleteOptionSection, isLoading: deleteOptionLoading } = useDeleteOptionSectionMutation();

    const { mutateAsync: deleteData, isLoading: deleteLoading } = useDeleteBomDataMutation();

    const handleDeleteItems = async (sectionIds: number[], productIds: number[], componentsFromPartialKits?: SelectedData[]) => {
        const promises = [];
        if (sectionIds.length) {
            promises.push(isOptionTable ? deleteOptionSection({ bomId: Number(bomId), sectionIds }) : deleteSection({ bomId: Number(bomId), sectionIds }))
        }
        if (productIds.length) {
            promises.push(deleteData({ bomId: bomId!, ids: productIds }))
        }
        await Promise.all(promises);
        if (productIds.length && tableRef && onPricingInfoEdit) {
            handleKitPricingUpdate({ onPricingInfoEdit, tableRef, type: 'delete', productIds, componentsFromPartialKits: componentsFromPartialKits?.length ? componentsFromPartialKits : undefined })
        }

        if (sectionIds.length) {
            pushUserEventCount({ eventType: 'section_deleted', needCummulation: true });
        }
    };

    return { handleDeleteItems, isLoading: deleteLoading || deleteSectionLoading || deleteOptionLoading }


}

export default useDeleteBods;